import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

export const firebaseConfig = {
  apiKey: 'AIzaSyDf-oWZ_sqw9T8vl4OjtukSYqyMcsGpDGM',
  authDomain: 'sawubona-project.firebaseapp.com',
  projectId: 'sawubona-project',
  storageBucket: 'sawubona-project.appspot.com',
  messagingSenderId: '646776098773',
  appId: '1:646776098773:web:150cfa98b86368bd38f75c',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
export const firestoreDatabaseId = process.env.REACT_APP_FIRESTORE_DATABASE_ID?.trim();
export const db = firestoreDatabaseId && firestoreDatabaseId !== '(default)'
  ? getFirestore(firebaseApp, firestoreDatabaseId)
  : getFirestore(firebaseApp);
